import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import matchSorter from "match-sorter";

import * as modalActions from "../../actions/modalActions";
// import * as contractActions from '../../actions/contractActions';
import * as customerActions from "../../actions/customerActions";
import * as userActions from "../../actions/userActions";
import * as expenseActions from "../../actions/expenseActions";
import * as projectActions from "../../actions/projectActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ExpenseList from "../expense/ExpenseList";
import ExpenseForm from "../expense/ExpenseForm";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

class CustomerExpensePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      defaultPageSize: localStorage.getItem("DEFAULT_PAGE_SIZE_EXPENSE_LIST")
        ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_EXPENSE_LIST"))
        : 10
    };
  }

  componentDidMount = () => {
    const { users, match, actions } = this.props;

    actions.loadExpensesByCustomerId(match.params.id);
    actions.loadProjects({ customer: match.params.id });

    if (!users.length) actions.loadUsers();
  };

  onClickAdd = () => {
    this.setState({ adding: true });
    this.props.actions.showModalSuccess("expenseDetailsModal");
  };

  onClickView = (expense) => {
    this.setState({ adding: false });
    this.props.actions.getExpense(expense, true);
  };

  onClickDelete = (expenseId) => {
    this.props.actions.requestExpenseId(expenseId);
  };

  onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_EXPENSE_LIST", pageSize);
    this.setState({ defaultPageSize: pageSize });
  };

  handleDelete = () => {
    this.props.actions.deleteExpense(this.props.expenseToDelete);
  };

  handleAdd = async (expense) => {
    await this.props.actions.createExpense(expense);
    await this.props.actions.loadExpensesByCustomerId(
      this.props.match.params.id
    );
  };

  handleSave = async (expense) => {
    await this.props.actions.updateExpense(expense);
    await this.props.actions.loadExpensesByCustomerId(
      this.props.match.params.id
    );
  };

  filter = (e) => this.setState({ search: e.target.value });

  render() {
    let {
      customer,
      expenses,
      expense,
      users,
      codes,
      saving,
      isMobile,
      auth,
      projects
    } = this.props;
    const { search, adding, defaultPageSize } = this.state;

    if (adding) {
      expense = {
        customer: customer._id
      };
    }

    const expenseForm = (
      <ExpenseForm
        expense={expense}
        customers={[customer]}
        customer={customer._id}
        codes={codes}
        users={users}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        adding={adding}
        saving={saving}
        editing
        auth={auth}
        ptojects={projects}
        hideReceiptDelete
      />
    );

    return (
      <div id="expenses">
        <HeaderWrapper
          breadcrumbs={[{ label: "Expenses" }]}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <ExpenseList
            minimal
            expenses={matchSorter(expenses, search, {
              keys: [
                "date",
                "employee.full_name",
                "customer.name",
                "category.label",
                "amount",
                "status.label"
              ]
            })}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            isMobile={isMobile}
            onPageSizeChange={this.onPageSizeChange}
            defaultPageSize={defaultPageSize}
          />
        </div>
        <Modal
          id="expenseDetailsModal"
          title={adding ? "Add Expense" : "Edit Expense"}
          body={expenseForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="expenseDeleteModal"
          title="Delete Expense"
          body="Are you sure you want to delete this expense?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </div>
    );
  }
}

CustomerExpensePage.propTypes = {
  actions: PropTypes.object.isRequired,
  match: PropTypes.object,
  customer: PropTypes.object,
  expense: PropTypes.object,
  saving: PropTypes.bool,
  isMobile: PropTypes.bool,
  projects: PropTypes.array,
  expenses: PropTypes.array,
  codes: PropTypes.array.isRequired,
  expenseToDelete: PropTypes.string,
  users: PropTypes.array,
  auth: PropTypes.object
};

CustomerExpensePage.defaultProps = {
  auth: null
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customer: state.reducers.customer,
    expense: state.reducers.expense,
    expenses: state.reducers.expenses,
    expenseToDelete: state.reducers.expenseToDelete,
    saving: state.reducers.savingExpense,
    users: state.reducers.users,
    codes: state.reducers.codes,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...expenseActions,
        ...customerActions,
        ...userActions,
        ...projectActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CustomerExpensePage)
);
